import React from "react";
import BpmnModeler from "./components/BpmnModeler/BpmnModeler";

export default function App() {
  return (
      <div className="App">
        <BpmnModeler />
      </div>
  );
}
